import {
  ENDPOINT_ROOT,
  ENDPOINT_USERS_SCANBAT_REGISTER,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const registerScanbat = ({ company, warehouse, recaptchaToken }) => {
  const params = {
    company_code: company,
    warehouse_code: warehouse,
    recaptcha_token: recaptchaToken,
  };

  return axiosAuth
    .post(`${ENDPOINT_ROOT}/${ENDPOINT_USERS_SCANBAT_REGISTER}`, params)
    .then((res) => res.data);
};

export default registerScanbat;
